import baseApi from "@/api/baseApi";

export default {
  fetch(id) {
    return baseApi.get(`api-blob/api/v1/storage/${id}`);
  },
  cancel(form) {
    return baseApi.post(`api-blob/api/v1/storage/cancel`, form);
  },
  requestDownload(id) {
    return baseApi.put(`api-blob/api/v1/storage/request-download?id=${id}`);
  }
}
